module.exports = "<ngx-loading [show]=\"loading\"></ngx-loading>\n<div>\n\n  <app-nav-menu></app-nav-menu>\n  <router-outlet></router-outlet>\n</div>\n\n"